window.Activity = {
  ...window.Activity, // `pageview` and `pageview_metadata` are defined in `_posthog.slim`

  track: function (category, action, label, value, properties = {}) {
    try {
      const base_properties = {
        category,
        action,
        label,
        value,
        source: "Activity.track",
      }
      const merged_properties = {
        ...this.pageview_metadata,
        ...properties,
        ...base_properties,
      }
      posthog.capture(`${category} ${action}`, merged_properties)
      gtag("event", action, { category, label, value })
    } catch (error) {
      console.log(error)
    }
  },

  capture: function (event, properties) {
    const merged_properties = {
      source: "Activity.capture",
      ...this.pageview_metadata,
      ...properties,
    }
    posthog.capture(event, merged_properties)
  },

  track_subscription: function (ptp_source) {
    this.capture("subscription create", { ptp_source })
  },

  track_search: function (terms) {
    this.track("Search", "search", terms.toLowerCase(), terms)
  },
}
